export const autocomplete = {
  INPUT_CHANGED: 'autocomplete.InputChanged',
  NO_RESULTS: 'autocomplete.NoResults'
}
